import { inject, Injectable } from '@angular/core';
import { ApiService } from '../../shared/services';
import { Observable } from 'rxjs';
import {
	AddLicenseDto,
	LicenseWithCompletionResource,
	PayloadRequest,
	PayloadResponse
} from '../models';

@Injectable({
	providedIn: 'root'
})
export class MyCoursesService {
	private apiService = inject(ApiService);

	getLicenseListByLearnerId(): Observable<
		PayloadResponse<LicenseWithCompletionResource[]>
	> {
		return this.apiService.get(`licenses/learner-licenses`);
	}

	addCourse(licenseCode: AddLicenseDto) {
		licenseCode = {
			code: licenseCode.code.trim()
		};

		const payload = new PayloadRequest<AddLicenseDto>({ data: licenseCode });
		return this.apiService.post(`learners/add-license-course-learner`, payload);
	}
}
